<template>
  <div class="kw_count_down">
    <span class="countdown-class">
      {{time}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'kw_count_down',
  props: {
    target: Number,
    showDay: Boolean,
    callback: String,
    format: Array,
    clearTimer: Boolean
  },
  data() {
    return {
      time: '',
      resultFormat: [],
      changeFormat: false
    };
  },
  created() {
    this.getFormat();
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    getFormat() {
        const that = this;

        if (!that.showDay) that.resultFormat.push('');
        if(that.format) {
          const len = that.format.length;
  
          if (len >= 3) {
              for (let i = 0; i < len; i++) {
                  if (that.resultFormat.length >= 4) break;
                  if (that.format[i]) {
                      that.resultFormat.push(that.format[i].toString());
                  }
              }
  
              if (that.resultFormat.length >= 4) that.changeFormat = true;
          }
        }

        that.getLastTime();
    },
    init() {
        const self = this;
        setTimeout(function () {
            self.getLastTime.call(self);
        }, 1000);
    },
    getLastTime() {
        const that = this;
        const gapTime = Math.ceil((that.target - new Date().getTime()) / 1000);
        let result = '';
        let time = '00:00:00';
        let day = '00';
        const format = that.resultFormat;

        if (gapTime > 0) {
            day = this.formatNum(parseInt(gapTime / 86400));
            let lastTime = gapTime % 86400;
            const hour = this.formatNum(parseInt(lastTime / 3600));
            lastTime = lastTime % 3600;
            const minute = this.formatNum(parseInt(lastTime / 60));
            const second = this.formatNum(lastTime % 60);

            if (that.changeFormat) time = `${hour}${format[1]}${minute}${format[2]}${second}${format[3]}`;
            else time = `${hour}:${minute}:${second}`;

            if (!that.clearTimer) this.init.call(this);
        } else {
            this.endfn();
        }

        if (that.showDay) {
            if (that.changeFormat) {
                result = `${day}${format[0]} ${time}`;
            } else {
                result = `${day}d ${time}`;
            }
        } else {
            result = time;
        }
        that.time = result;

    },
    formatNum(num) {
        return num > 9 ? num : `0${num}`;
    },
    endfn() {
      this.$emit('callback');
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
